export default "__VITE_ASSET__DG9_$yT3__"